/* global SideDrawer */

// ── Quick Add — Flersproget tekst-objekt ──────────────────────────────────────
// Sprog detekteres via <html lang="..."> sat af Shopify
// Understøttede sprog: da, nb/no, sv, fi, en, de, nl, fr, es, it, pt, ja
(function() {
  var rawLang = (document.documentElement.lang || 'da').toLowerCase().slice(0, 2);
  var lang = rawLang === 'no' ? 'nb' : rawLang;
  var QAT = {
    da: {
      details:       'Detaljer',
      see_product:   'Se produkt',
      see_product_full: 'Se fuld produktside',
      quantity:      'Antal',
      free_shipping: 'Fri fragt inkluderet',
      added:         '✓ Tilføjet!',
      fewer:         'Færre',
      more:          'Flere',
      sold_out:      'Udsolgt',
    },
    nb: {
      details:       'Detaljer',
      see_product:   'Se produkt',
      see_product_full: 'Se full produktside',
      quantity:      'Antall',
      free_shipping: 'Gratis frakt inkludert',
      added:         '✓ Lagt til!',
      fewer:         'Færre',
      more:          'Flere',
      sold_out:      'Utsolgt',
    },
    sv: {
      details:       'Detaljer',
      see_product:   'Se produkt',
      see_product_full: 'Se hela produktsidan',
      quantity:      'Antal',
      free_shipping: 'Fri frakt ingår',
      added:         '✓ Tillagd!',
      fewer:         'Färre',
      more:          'Fler',
      sold_out:      'Slutsåld',
    },
    fi: {
      details:       'Tiedot',
      see_product:   'Katso tuote',
      see_product_full: 'Katso koko tuotesivu',
      quantity:      'Määrä',
      free_shipping: 'Ilmainen toimitus sisältyy',
      added:         '✓ Lisätty!',
      fewer:         'Vähemmän',
      more:          'Enemmän',
      sold_out:      'Loppuunmyyty',
    },
    en: {
      details:       'Details',
      see_product:   'View product',
      see_product_full: 'View full product page',
      quantity:      'Quantity',
      free_shipping: 'Free shipping included',
      added:         '✓ Added!',
      fewer:         'Fewer',
      more:          'More',
      sold_out:      'Sold out',
    },
    de: {
      details:       'Details',
      see_product:   'Produkt ansehen',
      see_product_full: 'Vollständige Produktseite ansehen',
      quantity:      'Menge',
      free_shipping: 'Kostenloser Versand inklusive',
      added:         '✓ Hinzugefügt!',
      fewer:         'Weniger',
      more:          'Mehr',
      sold_out:      'Ausverkauft',
    },
    nl: {
      details:       'Details',
      see_product:   'Bekijk product',
      see_product_full: 'Bekijk volledige productpagina',
      quantity:      'Aantal',
      free_shipping: 'Gratis verzending inbegrepen',
      added:         '✓ Toegevoegd!',
      fewer:         'Minder',
      more:          'Meer',
      sold_out:      'Uitverkocht',
    },
    fr: {
      details:       'Détails',
      see_product:   'Voir le produit',
      see_product_full: 'Voir la page produit complète',
      quantity:      'Quantité',
      free_shipping: 'Livraison gratuite incluse',
      added:         '✓ Ajouté !',
      fewer:         'Moins',
      more:          'Plus',
      sold_out:      'Épuisé',
    },
    es: {
      details:       'Detalles',
      see_product:   'Ver producto',
      see_product_full: 'Ver página completa del producto',
      quantity:      'Cantidad',
      free_shipping: 'Envío gratuito incluido',
      added:         '✓ ¡Añadido!',
      fewer:         'Menos',
      more:          'Más',
      sold_out:      'Agotado',
    },
    it: {
      details:       'Dettagli',
      see_product:   'Vedi prodotto',
      see_product_full: 'Vedi pagina prodotto completa',
      quantity:      'Quantità',
      free_shipping: 'Spedizione gratuita inclusa',
      added:         '✓ Aggiunto!',
      fewer:         'Meno',
      more:          'Di più',
      sold_out:      'Esaurito',
    },
    pt: {
      details:       'Detalhes',
      see_product:   'Ver produto',
      see_product_full: 'Ver página completa do produto',
      quantity:      'Quantidade',
      free_shipping: 'Envio gratuito incluído',
      added:         '✓ Adicionado!',
      fewer:         'Menos',
      more:          'Mais',
      sold_out:      'Esgotado',
    },
    ja: {
      details:       '詳細',
      see_product:   '商品を見る',
      see_product_full: '商品ページを見る',
      quantity:      '数量',
      free_shipping: '送料無料',
      added:         '✓ 追加しました！',
      fewer:         '減らす',
      more:          '増やす',
      sold_out:      '売り切れ',
    },
  };
  window.QAT = QAT[lang] || QAT['en'];
})();
// ── End Quick Add translations ────────────────────────────────────────────────

if (!customElements.get('quick-add-drawer')) {
  class QuickAddDrawer extends SideDrawer {
    constructor() {
      super();
      this.content = this.querySelector('.js-product-details');
      this.footer = this.querySelector('.drawer__footer');
      this.form = this.querySelector('product-form');
      this.notification = this.querySelector('.js-added-to-cart');
      this.backBtn = this.querySelector('.drawer__back-btn');
      this.openCartDrawerLinks = this.querySelectorAll('.js-open-cart-drawer');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.fetch = null;
      this.fetchedUrls = [];
      this.quickAddButtonMouseEnterHandler = this.handleQuickAddButtonMouseEnter.bind(this);
      this.documentClickHandler = this.handleDocumentClick.bind(this);

      document.addEventListener('click', this.documentClickHandler);
      this.addEventListener('on:variant:change', this.handleVariantChange.bind(this));

      // FIX 8: Swipe-to-dismiss på mobil
      this._initSwipeToDismiss();

      this.openCartDrawerLinks.forEach((link) => {
        link.addEventListener('click', this.handleOpenCartClick.bind(this));
      });

      if (theme.device.hasHover && theme.mediaMatches.md) {
        document.querySelectorAll('.js-quick-add').forEach((button) => {
          this.bindQuickAddButtonMouseEnter(button);
        });

        if ('MutationObserver' in window) {
          this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              mutation.addedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-quick-add').forEach((button) => {
                    this.bindQuickAddButtonMouseEnter(button);
                  });
                }
              });
              mutation.removedNodes.forEach((node) => {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  node.querySelectorAll('.js-quick-add').forEach((button) => {
                    button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
                  });
                }
              });
            });
          });
          this.observer.observe(document.body, { childList: true, subtree: true });
        }
      }
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.documentClickHandler);
      document.querySelectorAll('.js-quick-add').forEach((button) => {
        button.removeEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      });
      if (this.observer) this.observer.disconnect();
    }

    bindQuickAddButtonMouseEnter(button) {
      if (!button.dataset.quickAddListenerAdded) {
        button.dataset.quickAddListenerAdded = 'true';
        button.addEventListener('mouseenter', this.quickAddButtonMouseEnterHandler);
      }
    }

    handleQuickAddButtonMouseEnter(evt) {
      if (!this.fetchedUrls.includes(evt.target.dataset.productUrl)) {
        this.fetch = {
          url: evt.target.dataset.productUrl,
          promise: fetch(evt.target.dataset.productUrl)
        };
        this.fetchedUrls.push(evt.target.dataset.productUrl);
      }
    }

    handleOpenCartClick(evt) {
      if (this.cartDrawer) {
        evt.preventDefault();
        this.cartDrawer.open();
      } else if (window.location.pathname === theme.routes.cart) {
        evt.preventDefault();
        this.close();
      }
    }

    handleDocumentClick(evt) {
      if (!evt.target.matches('.js-quick-add')) return;

      if (this.cartDrawer && this.cartDrawer.ariaHidden === 'false') {
        const overlay = document.querySelector('.js-overlay.is-visible');
        if (overlay) overlay.style.transitionDelay = '200ms';
        this.cartDrawer.close();
        setTimeout(() => {
          this.backBtn.hidden = false;
          this.open(evt.target);
          if (overlay) overlay.style.transitionDelay = '';
        }, 200);
      } else {
        this.open(evt.target);
      }
    }

    handleVariantChange(evt) {
      let url = this.productUrl;

      if (evt.detail.variant) {
        const separator = this.productUrl.split('?').length > 1 ? '&' : '?';
        url += `${separator}variant=${evt.detail.variant.id}`;

        // FIX 2: Opdater dynamisk pris i header når variant ændres
        this.updateDynamicPrice(evt.detail.variant);
      }

      this.querySelectorAll('.js-prod-link').forEach((link) => {
        link.href = url;
      });
    }

    /**
     * FIX 2: Opdater den dynamiske pris i panelet baseret på valgt variant
     */
    updateDynamicPrice(variant) {
      const priceEl = this.querySelector('.qa-dynamic-price');
      if (!priceEl || !variant) return;

      const price = variant.price;
      const comparePrice = variant.compare_at_price;
      const formatted = this.formatMoney(price);

      if (comparePrice && comparePrice > price) {
        const formattedCompare = this.formatMoney(comparePrice);
        priceEl.innerHTML = `
          <span class="qa-price-current">${formatted}</span>
          <span class="qa-price-was">${formattedCompare}</span>
        `;
      } else {
        priceEl.innerHTML = `<span class="qa-price-current">${formatted}</span>`;
      }
    }

    /**
     * Formatér pris fra cents til dansk format
     */
    formatMoney(cents) {
      const amount = (cents / 100).toFixed(0);
      return amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr';
    }

    async open(opener) {
      opener.setAttribute('aria-disabled', 'true');

      if (this.notification) this.notification.hidden = true;

      if (this.productUrl && this.productUrl === opener.dataset.productUrl) {
        super.open(opener);
        opener.removeAttribute('aria-disabled');
        return;
      }

      this.productUrl = opener.dataset.productUrl;
      this.content.innerHTML = '';
      this.classList.add('is-loading');
      this.content.classList.add('drawer__content--out');
      this.footer.classList.add('drawer__footer--out');

      super.open(opener);

      if (!this.fetch || this.fetch.url !== opener.dataset.productUrl) {
        this.fetch = {
          url: opener.dataset.productUrl,
          promise: fetch(opener.dataset.productUrl)
        };
      }

      const response = await this.fetch.promise;
      if (response.ok) {
        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();
        this.productEl = tmpl.content.querySelector('.cc-main-product .js-product');
        this.renderProduct(opener);
      }

      this.fetch = null;
      opener.removeAttribute('aria-disabled');
    }

    close() {
      super.close(() => {
        this.backBtn.hidden = true;
      });
    }

    renderProduct(opener) {
      const sectionId = this.productEl.dataset.section;
      this.productEl.innerHTML = this.productEl.innerHTML.replaceAll(sectionId, 'quickadd');

      const variantPicker = this.productEl.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.dataset.updateUrl = 'false';
        this.selectFirstVariant = variantPicker.dataset.selectFirstVariant === 'true';
      }

      const sizeChartModal = this.productEl.querySelector('[data-modal="size-chart"]');
      if (sizeChartModal) sizeChartModal.remove();

      this.updateContent();
      this.updateForm();

      setTimeout(() => this.transformSizeSelects(), 50);
      setTimeout(() => this.applyMobileGrid(), 120);

      const activeMedia = this.productEl.querySelector('.media-viewer__item.is-current-variant');
      if (activeMedia) this.updateMedia(activeMedia.dataset.mediaId);

      if (opener.dataset.selectedColor && this.selectFirstVariant) {
        setTimeout(this.setActiveVariant.bind(this, opener), 10);
      }
    }

    setActiveVariant(opener) {
      const colorOptionBox = this.querySelector(`.opt-btn[value="${opener.dataset.selectedColor}"]`);
      if (colorOptionBox) {
        this.querySelector(`.opt-btn[value="${opener.dataset.selectedColor}"]`).click();
      } else {
        const colorOptionDropdown = this.querySelector(
          `.custom-select__option[data-value="${opener.dataset.selectedColor}"]`
        );
        if (colorOptionDropdown) {
          const customSelect = colorOptionDropdown.closest('custom-select');
          customSelect.selectOption(colorOptionDropdown);
        }
      }
    }

    updateMedia(mediaId) {
      const img = this.productEl.querySelector(`[data-media-id="${mediaId}"] img`);
      if (!img) return;

      const src = img.src ? img.src.split('&width=')[0] : img.dataset.src.split('&width=')[0];
      const container = this.querySelector('.quick-add-info__media');
      const width = container.offsetWidth;
      const aspectRatio = img.width / img.height;

      // FIX 7: Gør billedet klikbart til produktsiden
      container.innerHTML = `
        <a href="${this.productUrl}" class="js-prod-link qa-media-link" tabindex="-1" aria-label="${window.QAT.see_product}">
          <img src="${src}&width=${width}" srcset="${src}&width=${width}, ${src}&width=${width * 2} 2x" width="${width * 2}" height="${(width * 2) / aspectRatio}" alt="${img.alt}">
        </a>
      `;
    }

    /**
     * FIX 5: Tjek om produktet berettiger til fri fragt
     */
    getFreeShippingStatus() {
      // Threshold: 800 kr = 80000 cents. Hent fra data-attribut hvis tilgængeligt.
      const threshold = parseInt(
        document.querySelector('[data-fsb-threshold]')?.dataset?.fsbThreshold ||
        document.querySelector('[data-free-shipping-threshold]')?.dataset?.freeShippingThreshold ||
        '80000',
        10
      );

      // Forsøg 1: data-price attribut på price element
      const priceEl = this.productEl.querySelector('[data-price]');
      if (priceEl && priceEl.dataset.price) {
        return parseInt(priceEl.dataset.price, 10) >= threshold;
      }

      // Forsøg 2: JSON-LD på produktsiden
      const jsonLd = this.productEl.querySelector('script[type="application/ld+json"]');
      if (jsonLd) {
        try {
          const data = JSON.parse(jsonLd.textContent);
          const offers = data.offers || (data['@graph'] || []).find(n => n.offers)?.offers;
          const lowestPrice = Array.isArray(offers)
            ? Math.min(...offers.map(o => parseFloat(o.price || 0))) * 100
            : parseFloat(offers?.price || 0) * 100;
          if (lowestPrice > 0) return lowestPrice >= threshold;
        } catch (e) { /* ignore */ }
      }

      // Forsøg 3: Aflæs synlig pris fra DOM
      const visiblePrice = this.productEl.querySelector('.price__current');
      if (visiblePrice) {
        const text = visiblePrice.textContent.replace(/[^0-9]/g, '');
        const priceCents = parseInt(text, 10) * 100;
        if (priceCents > 0) return priceCents >= threshold;
      }

      return false;
    }

    /**
     * Bygger markup for drawer-indholdet med alle 7 forbedringer
     */
    updateContent() {
      // FIX 1: Hent vendor/sku info
      const vendorSkuHtml = this.getElementHtml('.product-vendor-sku');

      // FIX 2: Hent aktuel pris
      const priceHtml = this.getElementHtml('.product-price');

      // FIX 5: Fri fragt status
      const hasFreeShipping = this.getFreeShippingStatus();
      const freeShippingBadge = hasFreeShipping
        ? `<span class="qa-free-shipping-badge">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M1 3h15v13H1V3zM16 8h4l3 3v5h-7V8z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
              <circle cx="5.5" cy="18.5" r="2.5" stroke="currentColor" stroke-width="2"/>
              <circle cx="19.5" cy="18.5" r="2.5" stroke="currentColor" stroke-width="2"/>
            </svg>
            ${window.QAT.free_shipping}
           </span>`
        : '';

      let weightElem = this.getElementHtml('.product-info__weight');
      if (weightElem && weightElem.length > 0) {
        weightElem = `<div class="product-info__weight text-sm mt-2">${weightElem}</div>`;
      }

      this.content.innerHTML = `
        <div class="quick-add-info grid mb-8">
          <div class="quick-add-info__media${theme.settings.blendProductImages ? ' image-blend' : ''}"></div>
          <div class="quick-add-info__details">

            <!-- FIX 4: Brand/Varenr/EAN som foldbar sektion + info-link i højre side -->
            <div class="qa-meta-header">
              <details class="qa-meta-details">
                <summary class="qa-meta-summary">
                  <span class="qa-meta-summary__text">${window.QAT.details}</span>
                  <svg class="qa-meta-summary__icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="6 9 12 15 18 9"/>
                  </svg>
                </summary>
                <div class="qa-meta-body product-vendor-sku text-sm">
                  ${vendorSkuHtml}
                </div>
              </details>
              <a href="${this.productUrl}" class="qa-info-link-icon js-prod-link" title="${window.QAT.see_product_full}" aria-label="${window.QAT.see_product_full}">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="8"/>
                  <line x1="12" y1="12" x2="12" y2="16"/>
                </svg>
                <span class="qa-info-link-text">${window.QAT.see_product}</span>
              </a>
            </div>

            <div class="product-title mt-2">
              <a class="qa-product-title js-prod-link" href="${this.productUrl}">
                ${this.getElementHtml('.product-title')}
              </a>
            </div>
            ${weightElem}
            <hr class="qa-divider">

            <!-- FIX 2: Dynamisk pris der opdateres ved variantskift -->
            <div class="qa-dynamic-price product-price">
              ${priceHtml}
            </div>

            <!-- FIX 5: Fri fragt badge -->
            ${freeShippingBadge}


          </div>
          <div class="quick-add-info__details md:hidden"></div>
        </div>
        <div class="product-options">
          ${this.getElementHtml('.product-options', '.custom-option:not(.quick-add-hidden)')}
        </div>

        <!-- FIX 6: Antal-vælger -->
        <div class="qa-qty-row">
          <span class="qa-qty-label">${window.QAT.quantity}</span>
          <div class="qa-qty-control">
            <button type="button" class="qa-qty-btn qa-qty-btn--minus" aria-label="${window.QAT.fewer}" data-qa-qty-change="-1">−</button>
            <input type="number" class="qa-qty-input" name="quantity" value="1" min="1" max="99" aria-label="${window.QAT.quantity}" readonly>
            <button type="button" class="qa-qty-btn qa-qty-btn--plus" aria-label="${window.QAT.more}" data-qa-qty-change="1">+</button>
          </div>
        </div>

        <div class="product-backorder">
          ${this.getElementHtml('.product-backorder')}
        </div>
      `;

      // Bind qty-knapper
      this.bindQtyControls();

      this.classList.remove('is-loading');
      this.content.classList.remove('drawer__content--out');
    }

    /**
     * FIX 6: Bind antal-vælger knapper
     */
    bindQtyControls() {
      const qtyInput = this.querySelector('.qa-qty-input');
      if (!qtyInput) return;

      this.querySelectorAll('[data-qa-qty-change]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const delta = parseInt(btn.dataset.qaQtyChange, 10);
          const current = parseInt(qtyInput.value, 10) || 1;
          const next = Math.max(1, Math.min(99, current + delta));
          qtyInput.value = next;

          // Opdater quantity i product-form
          const formQty = this.querySelector('product-form [name="quantity"]');
          if (formQty) formQty.value = next;
        });
      });
    }

    updateForm() {
      const productForm = this.productEl.querySelector('product-form');
      this.footer.classList.remove('quick-add__footer-message');

      if (productForm) {
        this.form.innerHTML = productForm.innerHTML;
        this.form.init();

        if (Shopify && Shopify.PaymentButton) {
          Shopify.PaymentButton.init();
        }
      } else {
        const signUpForm = this.productEl.querySelector('.product-signup');
        if (signUpForm) {
          this.form.innerHTML = signUpForm.innerHTML;
        } else {
          this.footer.classList.add('quick-add__footer-message');
          this.form.innerHTML = `
            <div class="alert quick-add__alert bg-info-bg text-info-text">
              <div class="flex">
                <div>
                  <svg class="icon icon--price_tag" width="32" height="32" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation">
                    <path fill="currentColor" d="M7.59 1.34a1 1 0 01.7-.29h5.66a1 1 0 011 1v5.66a1 1 0 01-.3.7L7.6 15.5a1 1 0 01-1.42 0L.52 9.83a1 1 0 010-1.42l7.07-7.07zm6.36 6.37l-7.07 7.07-5.66-5.66L8.3 2.05h5.66v5.66z" fill-rule="evenodd"/>
                    <path fill="currentColor" d="M9.7 6.3a1 1 0 101.42-1.42 1 1 0 00-1.41 1.41zM9 7a2 2 0 102.83-2.83A2 2 0 009 7z" fill-rule="evenodd"/>
                  </svg>
                </div>
                <div>
                  <p class="text-h6 font-bold mb-2">${theme.strings.awaitingSale}</p>
                  <a class="link js-prod-link" href="${this.productUrl}">${theme.strings.viewDetails}</a>
                </div>
              </div>
            </div>`;
        }
      }

      this.footer.classList.remove('drawer__footer--out');
    }

    getElementHtml(selector, ...additionalSelectors) {
      const selectors = [selector].concat(additionalSelectors);
      let html = '';
      selectors.forEach((sel) => {
        const els = this.productEl.querySelectorAll(sel);
        Array.from(els).forEach((el) => {
          html += el.innerHTML;
        });
      });
      return html;
    }

    /**
     * Transforms custom-select dropdowns for size options into a visual grid
     * with price per size, clear in-stock / sold-out indicators.
     */
    transformSizeSelects() {
      const optionGroups = this.querySelectorAll('.option-selector, .custom-option, .product-option');
      optionGroups.forEach((group) => {
        const label = group.querySelector('label, .label, .custom-option__label');
        if (!label) return;
        const labelText = label.textContent.toLowerCase();
        if (!labelText.includes('størrelse') && !labelText.includes('size')) return;

        const customSelect = group.querySelector('custom-select');
        if (!customSelect || customSelect.dataset.gridified === 'true') return;

        const options = customSelect.querySelectorAll('.custom-select__option');
        if (options.length === 0) return;

        // FIX 1: Byg grid med størrelse + pris per variant
        const grid = document.createElement('div');
        grid.className = 'qa-size-grid';

        options.forEach((opt) => {
          const value = opt.dataset.value;
          const text = opt.querySelector('span')?.textContent?.trim() || value;
          const isUnavailable = opt.classList.contains('is-unavailable');
          const isSelected = opt.getAttribute('aria-selected') === 'true';

          // Hent pris for denne variant fra data-attribut hvis tilgængeligt
          const variantPrice = opt.dataset.variantPrice || opt.dataset.price || '';
          const formattedPrice = variantPrice
            ? (parseInt(variantPrice, 10) / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr'
            : '';

          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'qa-size-btn' +
            (isUnavailable ? ' qa-size-btn--sold-out' : ' qa-size-btn--available') +
            (isSelected ? ' qa-size-btn--selected' : '');
          btn.dataset.value = value;
          btn.setAttribute('aria-label', text + (isUnavailable ? ' – ' + window.QAT.sold_out : ''));
          btn.disabled = isUnavailable;

          btn.innerHTML = `<span class="qa-size-btn__text">${text}</span>` +
            (formattedPrice ? `<span class="qa-size-btn__price">${formattedPrice}</span>` : '') +
            (isUnavailable ? '<span class="qa-size-btn__sold-out-line"></span>' : '');

          btn.addEventListener('click', () => {
            if (isUnavailable) return;
            customSelect.selectOption(opt);
            grid.querySelectorAll('.qa-size-btn').forEach(b => b.classList.remove('qa-size-btn--selected'));
            btn.classList.add('qa-size-btn--selected');
          });

          grid.appendChild(btn);
        });

        // Apply mobile grid layout via inline style (bypasses Tailwind .flex specificity)
        if (window.innerWidth <= 749) {
          // Dynamisk boks-højde: 8+ størrelser → 40px for at spare plads
          const btnHeight = options.length >= 8 ? '40px' : '48px';
          grid.style.setProperty('display', 'grid', 'important');
          grid.style.setProperty('grid-template-columns', 'repeat(auto-fill, minmax(44px, 1fr))', 'important');
          grid.style.setProperty('gap', '4px', 'important');
          // Apply compact styles to each button
          grid.querySelectorAll('.qa-size-btn').forEach((btn) => {
            btn.style.setProperty('min-width', 'unset', 'important');
            btn.style.setProperty('width', '100%', 'important');
            btn.style.setProperty('height', btnHeight, 'important');
            btn.style.setProperty('padding', '4px 2px', 'important');
          });
        }

        customSelect.style.display = 'none';
        customSelect.dataset.gridified = 'true';
        group.appendChild(grid);

        const observer = new MutationObserver(() => {
          const updatedOptions = customSelect.querySelectorAll('.custom-select__option');
          const gridBtns = grid.querySelectorAll('.qa-size-btn');
          updatedOptions.forEach((opt, i) => {
            if (!gridBtns[i]) return;
            const nowUnavailable = opt.classList.contains('is-unavailable');
            const nowSelected = opt.getAttribute('aria-selected') === 'true';
            gridBtns[i].className = 'qa-size-btn' +
              (nowUnavailable ? ' qa-size-btn--sold-out' : ' qa-size-btn--available') +
              (nowSelected ? ' qa-size-btn--selected' : '');
            gridBtns[i].disabled = nowUnavailable;
          });
        });
        observer.observe(customSelect, { subtree: true, attributes: true, attributeFilter: ['aria-selected', 'class'] });
      });
    }

    /**
     * Applies CSS Grid layout via inline style on .option-selector__btns containers
     * on mobile viewports. This bypasses Tailwind's .flex utility class which
     * cannot be overridden by external CSS media queries due to specificity.
     * Called after transformSizeSelects() to handle both custom-select and
     * native radio-button option layouts (M-Tac products use the latter).
     */
    applyMobileGrid() {
      if (window.innerWidth > 749) return;
      const containers = this.querySelectorAll('.option-selector__btns');
      containers.forEach((container) => {
        // Detect if this container holds swatches (colour pickers) or size buttons
        const isSwatchContainer = container.querySelector('.opt-label--swatch') !== null;

        if (isSwatchContainer) {
          // --- Colour swatch container: reduce size to 40px circles ---
          container.style.setProperty('display', 'flex', 'important');
          container.style.setProperty('flex-wrap', 'wrap', 'important');
          container.style.setProperty('gap', '8px', 'important');
          container.style.setProperty('margin-top', '0', 'important');
          const swatches = container.querySelectorAll('.opt-label--swatch');
          swatches.forEach((swatch) => {
            swatch.style.setProperty('width', '40px', 'important');
            swatch.style.setProperty('height', '40px', 'important');
            swatch.style.setProperty('min-width', '40px', 'important');
            swatch.style.setProperty('min-height', '40px', 'important');
          });
        } else {
          // --- Size button container: apply compact grid ---
          // Dynamisk højde: 8+ størrelser → 40px for at spare plads til antal-boks
          const labels0 = container.querySelectorAll('.ea-size-label, .opt-label--btn');
          const btnH = labels0.length >= 8 ? '40px' : '48px';
          container.style.setProperty('display', 'grid', 'important');
          container.style.setProperty('grid-template-columns', 'repeat(auto-fill, minmax(44px, 1fr))', 'important');
          container.style.setProperty('gap', '4px', 'important');
          container.style.setProperty('margin-top', '0', 'important');
          // Apply compact styles to each size label (ea-size-label or opt-label--btn)
          const labels = container.querySelectorAll('.ea-size-label, .opt-label--btn');
          labels.forEach((label) => {
            label.style.setProperty('margin', '0', 'important');
            label.style.setProperty('min-width', 'unset', 'important');
            label.style.setProperty('width', '100%', 'important');
            label.style.setProperty('min-height', btnH, 'important');
            label.style.setProperty('height', btnH, 'important');
            label.style.setProperty('padding', '4px', 'important');
            label.style.setProperty('overflow', 'hidden', 'important');
            label.style.setProperty('display', 'flex', 'important');
            label.style.setProperty('flex-direction', 'column', 'important');
            label.style.setProperty('align-items', 'center', 'important');
            label.style.setProperty('justify-content', 'center', 'important');
            // Compact font for size name span
            const spans = label.querySelectorAll('span');
            spans.forEach((span, idx) => {
              if (idx === 0) {
                span.style.setProperty('font-size', '11px', 'important');
                span.style.setProperty('line-height', '1.2', 'important');
                span.style.setProperty('white-space', 'nowrap', 'important');
                span.style.setProperty('letter-spacing', '-0.5px', 'important');
              } else {
                span.style.setProperty('font-size', '9px', 'important');
                span.style.setProperty('line-height', '1.1', 'important');
                span.style.setProperty('white-space', 'nowrap', 'important');
              }
            });
          });
        }
      });
    }

    addedToCart() {
      // FIX 9: Haptic feedback ved tilføj til kurv
      if ('vibrate' in navigator) {
        navigator.vibrate(50);
      }

      // FIX 10: Animeret bekræftelse på TILFØJ TIL KURV-knappen
      const addBtn = this.querySelector('[name="add"], .js-submit-btn, button[type="submit"]');
      if (addBtn) {
        const origText = addBtn.textContent;
        const origBg = addBtn.style.background;
        addBtn.textContent = window.QAT.added;
        addBtn.style.background = '#166534';
        addBtn.style.transition = 'background 0.3s';
        setTimeout(() => {
          addBtn.textContent = origText;
          addBtn.style.background = origBg;
        }, 1200);
      }

      if (this.notification) {
        setTimeout(() => {
          this.notification.hidden = false;
        }, 300);

        setTimeout(() => {
          this.notification.hidden = true;
        }, this.notification.dataset.visibleFor);
      }

      if (this.cartDrawer) {
        // FIX 11: Luk Quick Add HELT (inkl. overlay + body.fixed) FØR cart-drawer åbner.
        // Problemet var en race condition: super.close() fjerner body.fixed og overlay,
        // men cart-drawer.open() tilføjer dem igen med det samme — og de to overlays
        // stakker ovenpå hinanden og låser siden.
        // Løsning: Vent på at SideDrawer-animationen er færdig (300ms) + buffer (100ms)
        // inden cart-drawer åbnes. cart-drawer.open() kalder selv quickAddDrawer.close()
        // hvis den stadig er åben, men vi lukker den eksplicit her for at undgå konflikten.
        setTimeout(() => {
          this.close();
        }, 600);
        setTimeout(() => {
          // Dobbelttjek at Quick Add er lukket inden vi åbner kurv
          if (this.ariaHidden !== 'false') {
            this.cartDrawer.open();
          } else {
            // Fallback: vent lidt mere
            setTimeout(() => this.cartDrawer.open(), 200);
          }
        }, 1050);
      }
    }

    /**
     * FIX 8: Swipe-to-dismiss — brugere kan swipe panelet ned for at lukke det
     */
    _initSwipeToDismiss() {
      let startY = 0;
      let currentY = 0;
      let isDragging = false;
      const DISMISS_THRESHOLD = 80; // px ned for at lukke

      const onTouchStart = (e) => {
        // Kun aktiv når panelet er åbent
        if (this.ariaHidden === 'true') return;
        // Kun swipe fra toppen af panelet (drag handle område)
        const touch = e.touches[0];
        const rect = this.getBoundingClientRect();
        if (touch.clientY - rect.top > 60) return; // kun top 60px
        startY = touch.clientY;
        isDragging = true;
        this.style.transition = 'none';
      };

      const onTouchMove = (e) => {
        if (!isDragging) return;
        currentY = e.touches[0].clientY;
        const delta = Math.max(0, currentY - startY);
        this.style.transform = `translateY(${delta}px)`;
        // Fade overlay baseret på swipe-afstand
        const overlay = document.querySelector('.js-overlay.is-visible');
        if (overlay) overlay.style.opacity = Math.max(0, 1 - delta / 200);
      };

      const onTouchEnd = () => {
        if (!isDragging) return;
        isDragging = false;
        const delta = currentY - startY;
        this.style.transition = '';
        const overlay = document.querySelector('.js-overlay.is-visible');
        if (overlay) overlay.style.opacity = '';

        if (delta > DISMISS_THRESHOLD) {
          // Swipe ned — luk panelet
          if ('vibrate' in navigator) navigator.vibrate(30);
          this.close();
        } else {
          // Snap tilbage
          this.style.transform = '';
        }
        startY = 0;
        currentY = 0;
      };

      this.addEventListener('touchstart', onTouchStart, { passive: true });
      this.addEventListener('touchmove', onTouchMove, { passive: true });
      this.addEventListener('touchend', onTouchEnd, { passive: true });
    }
  }

  customElements.define('quick-add-drawer', QuickAddDrawer);
}
